import ReviewRenderer from "../review/reviewRenderer";

export default function addReviewStyling(survey) {
  const renderer = new ReviewRenderer(survey);
  renderer.init();
}
